
import { ArrowBack, Edit } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Button from "../../../../components/Button/Button";
import styles from "./AddCustomer.module.css";

import Documents from "./Documents";
import FinancialEntriesList from "./FinancialEntriesList";
import FormCustomer from "./FormCustomer";

const AddCustomer = () => {
  const navigate = useNavigate();
  const { uid } = useParams();

  const [isViewMode, setIsViewMode] = useState(false);

  const [dropDown, setDropDown] = useState("");

  const handleGoBack = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate("/admin/requests/customers");
  };

  const handleToggleEditMode = () => {
    if (!isViewMode) {
      setIsViewMode(true);
    } else {
      setIsViewMode(false);
    }
  };

  useEffect(() => {
    setIsViewMode(!!uid);
  }, [uid]);

  const handleDropDown = (id: string) => {
    let value = id;
    if (dropDown === value) {
      value = "";
    }
    setDropDown(value);
  };

  return (
    <div className={styles.containerPage}>
      <div className={styles.headerPage}>
        <h1>Cadastro de Cliente</h1>

        <div className={styles.headerButtons}>
          {uid && (
            <Button
              variant="contain"
              onClick={handleToggleEditMode}
              type="button"
              title={isViewMode ? "Editar" : "Cancelar Edição"}
            >
              <Edit />
            </Button>
          )}

          <Button
            variant="contain"
            onClick={handleGoBack}
            type="button"
            title="Voltar"
          >
            <ArrowBack />
          </Button>
        </div>
      </div>

      <div className={styles.formContainer}>
        <div className={styles.formHeader}>
          <h2>DADOS DO CLIENTE</h2>
        </div>

        <div className={styles.formContent}>
          <FormCustomer
            handleViewMode={(state) => setIsViewMode(state)}
            isViewMode={isViewMode}
            uid={uid}
          />
        </div>
      </div>

      <div className={styles.container}>
        <div
          className={styles.formContainer}
          onClick={() => handleDropDown("CONTAS_RECEBER")}
        >
          <div className={styles.formHeader}>
            <h2>CONTAS A RECEBER</h2>
          </div>
          {dropDown === "CONTAS_RECEBER" && (
            <div className={styles.formContent}>
              <FinancialEntriesList uid_cliente={uid || ""} />
            </div>
          )}
        </div>
        <div className={styles.formContainer}>
          <Documents uid_cliente={uid || ""} />
        </div>
      </div>
    </div>
  );
};

export default AddCustomer;
